var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-browser-height',{staticClass:"repository-tree-list",style:({ width: `${_vm.treeWidth}px` })},[(!_vm.isLoading)?_c('tree-list',{staticClass:"gl-mr-5 gl-mt-5",attrs:{"total-files-count":_vm.totalFilesCount}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }